import * as B from '../../BountyDetailParts'

export const BountyDetailRejected = ({
  data,
  ...props
}: Omit<B.PageProps, 'children'>) => {
  return (
    <B.Page data={data} {...props}>
      <B.SparkCodes />
      <B.SectionGroup>
        <B.TitleRow />
        <B.StatusCard>
          <B.StatusHeading>Rejected</B.StatusHeading>
          <B.StatusParagraph>
            We could not approve your video.
          </B.StatusParagraph>
        </B.StatusCard>
        <B.LiveVideoPreview />
      </B.SectionGroup>
      <B.Feedback />
      <B.OrderDetails />
      <B.CommunityRules />
    </B.Page>
  )
}
